import get from 'lodash.get';

const getAvailableSubscriptionTypes = (rootState) =>
  get(rootState, 'user.partnerData.properties.availableSubscriptionTypes', []);

export default getAvailableSubscriptionTypes;
